<template>
  <el-dialog
    class="dialog-container"
    :visible.sync="dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    title="添加专家"
    center
  >
    <div class="flex flex-direction padding">
      <el-form
        class="ruleForm"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="auto"
      >
        <el-form-item prop="nickname" label="专家名称">
          <el-input v-model="ruleForm.nickname" placeholder="请输入专家名称">
          </el-input>
        </el-form-item>
        <el-form-item prop="username" label="登录账号">
          <el-input
            v-model="ruleForm.username"
            placeholder="请输入登录账号，为空则不修改"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password" label="登录密码">
          <el-input
            v-model="ruleForm.password"
            placeholder="请输入登录密码，为空则不修改"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="role_type" label="角色">
          <el-radio-group v-model="ruleForm.role_type">
            <el-radio
              v-for="item in expert_role_types"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="check_project_id" label="项目方向">
          <el-select
            style="width: 100%"
            v-model="ruleForm.project_direction"
            multiple
            filterable
            placeholder="请选择项目方向"
            @change="changeProjectDirection"
          >
            <el-option
              v-for="item in project_directions"
              :key="item.id"
              :label="item.class_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="check_project_id" label="初审项目">
          <el-select
            style="width: 100%"
            v-model="ruleForm.check_project_id"
            multiple
            filterable
            placeholder="请选择初审项目"
          >
            <el-option
              v-for="item in check_options"
              :key="item.id"
              :label="item.project_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="recheck_project_id" label="项目方向">
          <el-select
            style="width: 100%"
            v-model="ruleForm.recheck_project_direction"
            multiple
            filterable
            placeholder="请选择项目方向"
            @change="changeRecheckProjectDirection"
          >
            <el-option
              v-for="item in project_directions"
              :key="item.id"
              :label="item.class_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="recheck_project_id" label="复审项目">
          <el-select
            style="width: 100%"
            v-model="ruleForm.recheck_project_id"
            multiple
            filterable
            placeholder="请选择复审项目"
          >
            <el-option
              v-for="item in recheck_options"
              :key="item.id"
              :label="item.project_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-operate flex align-center justify-center">
        <el-button class="btn min round" type="info" @click="cancel"
          >取消</el-button
        >
        <el-button
          class="btn min round"
          type="primary"
          @click="submitForm('ruleForm')"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getCheckProjectList,
  getProjectClassDirectionList,
  insertAdminInfo,
} from "@/api/admin";
import { expert_role_types } from "@/utils/utils";

export default {
  name: "AddExpertDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    info: {
      type: [String, Object],
      default: "",
    },
  },
  data() {
    return {
      expert_role_types: expert_role_types,
      check_options: [],
      recheck_options: [],
      project_directions: [],

      ruleForm: {
        nickname: "",
        username: "",
        password: "",
        role_type: "",
        project_direction: [],
        copy_project_direction: [],
        copy_recheck_project_direction: [],
        check_project_id: [],
        recheck_project_id: [],
        recheck_project_direction: [],
      },
      rules: {
        nickname: [{ required: true, message: "请输入", trigger: "blur" }],
        username: [{ required: true, message: "请输入", trigger: "blur" }],
        password: [{ required: true, message: "请输入", trigger: "blur" }],
        role_type: [{ required: true, message: "请选择", trigger: "blur" }],
      },
    };
  },
  created() {},
  methods: {
    async init() {
      let _data = await getCheckProjectList(1);
      this.check_options = _data.data.data;
      _data = await getCheckProjectList(2);
      this.recheck_options = _data.data.data;
      _data = await getProjectClassDirectionList();
      this.project_directions = _data.data;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        }
      });
    },
    async save() {
      let _data = await insertAdminInfo(
        (this.info && this.info.id) || "",
        this.ruleForm.nickname,
        this.ruleForm.username,
        this.ruleForm.password,
        this.ruleForm.role_type,
        2,
        this.ruleForm.project_direction.join(","),
        this.ruleForm.check_project_id.join(","),
        this.ruleForm.recheck_project_id.join(","),
        this.ruleForm.recheck_project_direction.join(",")
      );
      if (_data.code == 200) {
        this.$message.success(_data.message);
        this.$emit("watchState", {
          obj: this.ruleForm,
        });
        this.clearContent();
      } else {
        this.$message.error(_data.message);
      }
    },
    changeRecheckProjectDirection(val) {
      //判断是添加还是取消，取消处理 recheck_project_id 、check_project_id中的数据
      if (val.length > this.ruleForm.copy_recheck_project_direction.length) {
        let _last_val = val[val.length - 1];
        let _checks = this.recheck_options
          .filter((f) => {
            return _last_val === f.project_direction;
          })
          .map((item) => {
            return item.id;
          });
        //去从合并_checks 、this.ruleForm.check_project_id
        this.ruleForm.recheck_project_id = Array.from(
          new Set([...this.ruleForm.recheck_project_id, ..._checks])
        );
      } else {
        let _cancel_val = this.ruleForm.copy_recheck_project_direction.filter(
          (f) => {
            return !val.includes(f);
          }
        )[0];
        let _cancel_checks = this.recheck_options
          .filter((f) => {
            return _cancel_val === f.project_direction;
          })
          .map((item) => {
            return item.id;
          });
        this.ruleForm.recheck_project_id =
          this.ruleForm.recheck_project_id.filter((f) => {
            return !_cancel_checks.includes(f);
          });
      }
      this.ruleForm.copy_recheck_project_direction = val;
    },
    changeProjectDirection(val) {
      //判断是添加还是取消，取消处理 recheck_project_id 、check_project_id中的数据
      if (val.length > this.ruleForm.copy_project_direction.length) {
        let _last_val = val[val.length - 1];
        let _checks = this.check_options
          .filter((f) => {
            return _last_val === f.project_direction;
          })
          .map((item) => {
            return item.id;
          });
        //去从合并_checks 、this.ruleForm.check_project_id
        this.ruleForm.check_project_id = Array.from(
          new Set([...this.ruleForm.check_project_id, ..._checks])
        );
      } else {
        let _cancel_val = this.ruleForm.copy_project_direction.filter((f) => {
          return !val.includes(f);
        })[0];
        let _cancel_checks = this.check_options
          .filter((f) => {
            return _cancel_val === f.project_direction;
          })
          .map((item) => {
            return item.id;
          });
        this.ruleForm.check_project_id = this.ruleForm.check_project_id.filter(
          (f) => {
            return !_cancel_checks.includes(f);
          }
        );
      }
      this.ruleForm.copy_project_direction = val;
    },
    clearContent() {
      this.$refs.ruleForm.resetFields();
    },
    cancel() {
      this.$emit("watchState", false);
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.init();
        if (this.info) {
          this.rules.username[0].required = false;
          this.rules.password[0].required = false;
          this.ruleForm.nickname = this.info.nickname;
          this.ruleForm.username = this.info.username;
          this.ruleForm.role_type = this.info.role_type;
          this.ruleForm.project_direction = this.info.project_direction
            ? this.info.project_direction.split(",").map(Number)
            : [];
          this.ruleForm.recheck_project_direction = this.info
            .recheck_project_direction
            ? this.info.recheck_project_direction.split(",").map(Number)
            : [];
          this.ruleForm.check_project_id = this.info.check_project_id
            ? this.info.check_project_id.split(",").map(Number)
            : [];
          this.ruleForm.recheck_project_id = this.info.recheck_project_id
            ? this.info.recheck_project_id.split(",").map(Number)
            : [];
        } else {
          this.rules.username[0].required = true;
          this.rules.password[0].required = true;
          this.ruleForm.nickname = "";
          this.ruleForm.username = "";
          this.ruleForm.password = "";
          this.ruleForm.role_type = "";
          this.ruleForm.project_direction = [];
          this.ruleForm.check_project_id = [];
          this.ruleForm.recheck_project_id = [];
        }
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
